<template>
    <div>
        <div class="ibox animated fadeInRightBig">
            <div class="ibox-title">
                <h3>Novo Usuário <i class="fa fa-user-circle" style="float:right;font-size:21px;margin-top: -5px;"></i></h3>
            </div>
            <form id="form">
                <div class="ibox-content">
                    <div class="row">
                        <div class="form-group col-md-4">
                            <label for="name"><span class="required">*</span> Nome</label>
                            <input type="text" class="form-control" name="name" v-model="users.name" id="name"
                                placeholder="Nome do usuário">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="registry"><span class="required">*</span> Matrícula do Usuário</label>
                            <input type="text" class="form-control" name="registry" v-model="users.registry" id="registry"
                                placeholder="xxxxxxxx">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="email"><span class="required">*</span> E-mail do Usuário</label>
                            <input type="email" class="form-control" name="email" v-model="users.email" id="email" readonly
                                placeholder="nome@empresa.com.br">
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-3">
                            <label for="shift_id"><span class="required">*</span> Turno</label>
                            <select name="shift_id" class="form-control" id="shift_id" v-model="users.shift_id">
                                <option value=""  disabled selected hidden>Selecione uma opção</option>
                                <option :value="shift.id" v-for="shift in shifts" v-bind:key="shift.id">{{ shift.name }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group col-md-3">
                            <label for="team_id"><span class="required">*</span> Área</label>
                            <select name="team_id" class="form-control" v-model="users.team_id" id="team_id">
                                <option value="" disabled selected hidden>Selecione uma opção</option>
                                <option :value="team.id" v-for="team in teams" v-bind:key="team.id">{{ team.name }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-3">
                            <label for="role_id"><span class="required">*</span> Cargo</label>
                            <select name="role_id" class="form-control" v-model="users.role_id" id="role_id">
                                <option value=""  disabled selected hidden>Selecione uma opção</option>
                                <option :value="role.id" v-for="role in roles" v-bind:key="role.id">{{ role.name }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-3">
                            <label for="userType"><span class="required">*</span> Tipo de acesso</label>
                            <select name="userType" class="form-control" v-model="users.userType" id="userType">
                                <option value=""  disabled selected hidden>Selecione uma opção</option>
                                <option value="Administrador">Administrador</option>
                                <option value="Colaborador">Colaborador</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <label for="user_branch"><span class="required">*</span>Unidade</label>
                            <select name="user_branch" class="form-control" v-model="users.user_branches" id="user_branch">
                                <option value=""  disabled selected hidden>Selecione uma opção</option>
                                <option :value="branche.id" v-for="branche in branches" v-bind:key="branche.id">{{ branche.name }}</option>
                            </select>

                        </div>
                        <div class="form-group col-md-3">
                            <label for="password"><span class="required">*</span> Senha</label>
                            <input type="password" name="password" class="form-control" id="password" readonly
                                placeholder="***********" v-model="users.password">
                        </div>
                        <div class="form-group col-md-3">
                            <label for="password"><span class="required">*</span>Confirmar Senha</label>
                            <input type="password" name="confirmed_password" class="form-control" id="confirmed_password"
                                readonly placeholder="***********" v-model="users.confirmed_password">
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <label for="photo">Foto</label>
                            <input type="file" name="photo" id="photo" class="form-control">
                        </div>
                    </div>
                </div>

                <div class="ibox-footer">
                    <div class="pull-right">
                        <router-link to="/users" class="btn btn-info">
                            <i class="fa fa-arrow-left"></i> Voltar
                        </router-link>
                        <a class="btn btn-success" @click="save">
                            Salvar <i class="fa fa-save"></i>
                        </a>
                    </div>
                    <p><span class="required">*</span> Campos Obrigatórios</p>
                    <div class="clearfix"></div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert';

export default {
    data() {
        return {
            users: {
                name: '',
                email: '',
                password: '',
                confirmed_password: '',
                registry: '',
                photo: '',
                shift_id: '',
                role_id: '',
                userType: '',
                user_branches: '',
            },
            branches: [],
            shifts: [],
            roles: [],
            teams: [],
            errors: undefined
        }
    },
    computed: {},
    methods: {
        checkConfirmation() {

            if (this.users.password == this.users.confirmed_password) {
                return true;
            } else {
                swal("Ops! Senhas não coincidem. Tente novamente.");
                return false;
            }

        },
        save: function () {
            const api = this.$store.state.api + 'users';
            const self = this;

            let form = new FormData();
            let photo = document.getElementById('photo');

            form.append('name', self.users.name);
            form.append('email', self.users.email);
            form.append('registry', self.users.registry);
            form.append('password', self.users.password);
            form.append('photo', (photo.files[0]) ? photo.files[0] : null);
            form.append('shift_id', self.users.shift_id);
            form.append('team_id', self.users.team_id);
            form.append('role_id', self.users.role_id);
            form.append('userType', self.users.userType);
            form.append('user_branches', self.users.user_branches);

            if (this.checkConfirmation()) {
                self.$http.post(api, form)
                    .then((response) => {
                        self.users = response.data.data;
                        self.tableData = self.users;


                        self.$message('Sucesso', `Usuário cadastrado com sucesso`, 'success');

                        self.users = {

                            name: '',
                            email: '',
                            password: '',
                            registry: '',
                            photo: '',
                            shift_id: '',
                            role_id: '',
                            team_id: '',
                            userType: '',
                            user_branches:'',
                        };
                        this.$router.push('/users');

                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if (typeof self.errors === 'object') {
                            let html = '<ul>';

                            $.each(self.errors, function (key, value) {
                                html += '<li>' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });

            }

        },
        getShifts: function () {
            let api = this.$store.state.api + 'shifts';
            let self = this;

            self.$http.get(api)
                .then((response) => {
                    self.shifts = response.data.data;
                })
                .catch((error) => {
                    self.errors = error.response.data;
                    self.$message(null, 'Ocorreu um erro ao carregar as informações', 'error');
                });
        },
        getBranches: function () {
            let api = this.$store.state.api + "branches/?&paginated=false";
            let self = this;

            self.$http
                .get(api)
                .then((response) => {
                    console.log(response);
                    self.branches = response.data.data;
                })
                .catch((error) => {
                    self.errors = error.response.data;
                    self.$message(
                        null,
                        "Ocorreu um erro ao carregar as informações",
                        "error"
                    );
                });
        },
        getTeams: function () {
            let api = this.$store.state.api + 'teams?paginated=false';
            let self = this;

            self.$http.get(api)
                .then((response) => {
                    self.teams = response.data.data;
                })
                .catch((error) => {
                    self.errors = error.response.data;
                    self.$message(null, 'Ocorreu um erro ao carregar as informações', 'error');
                });
        },
        getRoles: function () {
            let api = this.$store.state.api + 'roles?paginated=false';
            let self = this;

            self.$http.get(api)
                .then((response) => {
                    self.roles = response.data.data;
                })
                .catch((error) => {
                    self.errors = error.response.data;
                    self.$message(null, 'Ocorreu um erro ao carregar as informações', 'error');
                });
        },
        loadMessage() {
            let senha = document.getElementById("password");
            let email = document.getElementById("email");
            let confirmaSenha = document.getElementById("confirmed_password");

            senha.removeAttribute("readonly");
            email.removeAttribute("readonly");
            confirmaSenha.removeAttribute("readonly");
        },
    },
    mounted: function () {
        setTimeout(() => {
            this.loadMessage();
        }, 300);
        this.getShifts();
        this.getRoles();
        this.getTeams();
        this.getBranches();

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label::after {
    content: ":";
    margin-right: 5px; 
}
</style>



// WEBPACK FOOTER //
// src/components/User/Add.vue